export enum QuoteStatus {
    QuoteApproved = 'QA'
    , QuotePending = 'PA'
    , QuoteDraft = 'QD'
    , QuoteRevision = 'RR'
    , QuoteReject = 'QR'
}


// WEBPACK FOOTER //
// ./src/enums/quotestatus.enum.ts